import styled from 'styled-components';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

import { Box, Stack } from 'src/viewLayer/components/DesignSystem';
import devices from 'src/viewLayer/styling/mixins/media-queries';

export const InputNodeContainer = styled(Box)`
  background-color: 'transparent';
  margin: ${`${tokens.size.space.large} ${tokens.size.space.small}`};
  width: 100%;
  @media ${devices.fromxsmall} {
    margin: ${tokens.size.space.large} ${tokens.size.space.small};
  }
  @media ${devices.frommedium} {
    margin: ${tokens.size.space.xxlarge} ${tokens.size.space.small};
  }
`;

export const InputContainer = styled(Stack)`
  gap: ${tokens.size.space.large};
  @media ${devices.frommedium} {
    gap: ${tokens.size.space.xlarge};
  }
`;
